/**
 * POST payload for endpoint /api/users/{domain}/createServiceAccount
 */
export class CreateServiceAccountRequest {
    steward: string;
    applicationId: string;
    usageLocationCode: string;
    givenName: string;
}